import React from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { RootState } from 'src/reducers';

import LibreAppWrapper from 'Containers/LibreAppWrapper';

import InvitationCode from 'Components/consent/InvitationCode';

const mapState = ({ partner: { connected, partners, pendingConnections } }: RootState) => {
  return {
    partners,
    connected,
    pendingConnections,
  };
};

const connector = connect(mapState);

type Props = ConnectedProps<typeof connector>;

const appConfig = {
  id: 'invitation',
  logo: '',
  transGroupKey: 'OtherConnections',
};

const Invitation: React.FC<React.PropsWithChildren<Props>> = ({
  partners,
  connected,
  pendingConnections,
}) => {
  return (
    <LibreAppWrapper app={appConfig} appType="otherConnections">
      <InvitationCode
        partners={partners}
        connected={connected}
        pendingConnections={pendingConnections}
      ></InvitationCode>
    </LibreAppWrapper>
  );
};

export default connector(Invitation);
